import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const FooterBase = styled.footer`
  padding: ${theme.spacing[8]} ${theme.spacing[4]};
  font-size: ${theme.fontSizes[2]};
  color: ${theme.colors.darkBlues[50]};
  background-color: #15325b;
  position: relative;
  z-index: 2;

  a {
    color: ${theme.colors.darkBlues[10]};

    &:hover {
      color: ${theme.colors.white};
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin-bottom: ${theme.spacing[1.5]};
    }
  }
`;
